import AutoFixHighOutlined from '@mui/icons-material/AutoFixHighOutlined';
import AutoFixHigh from '@mui/icons-material/AutoFixHigh';
import Label from '@mui/icons-material/Label';
import LabelOutlined from '@mui/icons-material/LabelOutlined';
import List from '@mui/icons-material/List';
import Pause from '@mui/icons-material/Pause';
import PauseOutlined from '@mui/icons-material/PauseOutlined';
import History from '@mui/icons-material/History';
import DoNotDisturb from '@mui/icons-material/DoNotDisturb';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import FileDownload from '@mui/icons-material/FileDownload';
import Check from '@mui/icons-material/Check';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Close from '@mui/icons-material/Close';
import Cancel from '@mui/icons-material/Cancel';
import PlayArrow from '@mui/icons-material/PlayArrow';
import PlayArrowOutlined from '@mui/icons-material/PlayArrowOutlined';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import Delete from '@mui/icons-material/Delete';
import Refresh from '@mui/icons-material/Refresh';
import DoneAll from '@mui/icons-material/DoneAll';
import BeenhereOutlined from '@mui/icons-material/BeenhereOutlined';
import Beenhere from '@mui/icons-material/Beenhere';
import DeleteForeverOutlined from '@mui/icons-material/DeleteForeverOutlined';
import DeleteForever from '@mui/icons-material/DeleteForever';
import DriveFileMoveOutlined from '@mui/icons-material/DriveFileMoveOutlined';
import DriveFileMove from '@mui/icons-material/DriveFileMove';
import DeleteSweepOutlined from '@mui/icons-material/DeleteSweepOutlined';
import SwapHoriz from '@mui/icons-material/SwapHoriz';
import ShareOutlined from '@mui/icons-material/ShareOutlined';
import Share from '@mui/icons-material/Share';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import Assessment from '@mui/icons-material/Assessment';
import FolderDeleteOutlined from '@mui/icons-material/FolderDeleteOutlined';
import FolderDelete from '@mui/icons-material/FolderDelete';
import PersonAddOutlined from '@mui/icons-material/PersonAddOutlined';
import PersonAdd from '@mui/icons-material/PersonAdd';
import CreateNewFolderOutlined from '@mui/icons-material/CreateNewFolderOutlined';
import CreateNewFolder from '@mui/icons-material/CreateNewFolder';
import RestoreFromTrashOutlined from '@mui/icons-material/RestoreFromTrashOutlined';
import RestoreFromTrash from '@mui/icons-material/RestoreFromTrash';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import DeleteSweep from '@mui/icons-material/DeleteSweep';
import EditOutlined from '@mui/icons-material/EditOutlined';
import Edit from '@mui/icons-material/Edit';
import Key from '@mui/icons-material/Key';
import KeyOutlined from '@mui/icons-material/KeyOutlined';
import RestartAlt from '@mui/icons-material/RestartAlt';
import RestartAltOutlined from '@mui/icons-material/RestartAltOutlined';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Add from '@mui/icons-material/Add';

const iconMap = {
  acknowledge: { outlined: BeenhereOutlined, standard: Beenhere },
  applyTemplate: { outlined: AutoFixHighOutlined, standard: AutoFixHigh },
  block: { outlined: DoNotDisturb, standard: DoNotDisturb },
  check: { outlined: CheckCircle, standard: CheckCircle },
  close: { outlined: Cancel, standard: Cancel },
  cloneMember: { outlined: PersonAddOutlined, standard: PersonAdd },
  createFolder: {
    outlined: CreateNewFolderOutlined,
    standard: CreateNewFolder,
  },
  complete: { outlined: DoneAll, standard: DoneAll },
  delete: { outlined: DeleteOutlined, standard: Delete },
  deleteFilled: { outlined: Delete, standard: Delete },
  deleteForever: { outlined: DeleteForeverOutlined, standard: DeleteForever },
  disable: { outlined: Close, standard: Close },
  edit: { outlined: EditOutlined, standard: Edit },
  enable: { outlined: Check, standard: Check },
  export: { outlined: FileDownloadOutlined, standard: FileDownload },
  folderDelete: { outlined: FolderDeleteOutlined, standard: FolderDelete },
  history: { outlined: History, standard: History },
  key: { outlined: KeyOutlined, standard: Key },
  label: { outlined: LabelOutlined, standard: Label },
  list: { outlined: List, standard: List },
  link: { outlined: LinkOutlined, standard: LinkOutlined },
  move: { outlined: DriveFileMoveOutlined, standard: DriveFileMove },
  pause: { outlined: PauseOutlined, standard: Pause },
  quickReport: { outlined: AssignmentOutlined, standard: Assessment },
  refresh: { outlined: Refresh, standard: Refresh },
  reset: { outlined: RestartAltOutlined, standard: RestartAlt },
  restoreFromTrash: {
    outlined: RestoreFromTrashOutlined,
    standard: RestoreFromTrash,
  },
  run: { outlined: PlayArrowOutlined, standard: PlayArrow },
  share: { outlined: ShareOutlined, standard: Share },
  sweep: { outlined: DeleteSweepOutlined, standard: DeleteSweep },
  transfer: { outlined: SwapHoriz, standard: SwapHoriz },

  add: { outlined: Add, standard: Add },
  downward: { outlined: ExpandMore, standard: ExpandMore },
  upward: { outlined: ExpandLess, standard: ExpandLess },
};

export type AppIconVariant = keyof typeof iconMap;

export function useAppIcon(variant: AppIconVariant) {
  const IconComponents = iconMap[variant];
  return IconComponents.outlined;
}
